(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  const init = function () {

    try {
      logger = new window.RussMedia.Utils.Logger("[topic cloud] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let parsedTopicCloudDataNode = parseTopicCloudData();
    if (!parsedTopicCloudDataNode) {
      logger.log("init: No topic cloud data.");
      return;
    }

    renderTopicCloud(parsedTopicCloudDataNode);

  };

  const parseTopicCloudData = function () {
    const topicCloudDataNode = document.querySelector("#topicCloudDataNode");

    let parsedTopicData = {};

    try {
      parsedTopicData = JSON.parse(topicCloudDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    parsedTopicData.hits = parsedTopicData.hits || [];
    parsedTopicData.hits = parsedTopicData.hits.map((rawPostData) => {
      return {
        id: rawPostData.id,
        link: rawPostData.link || null,
        slug: rawPostData.slug || '',
        title: rawPostData.title.rendered || '',
      };
    });

    return parsedTopicData;
  };

  const renderTopicCloud = (topicCloudData) => {
    Vue.createApp({
      components: {
        TopicCloud: window['@russmedia-frontend/np-topics'].TopicCloud,
      },
      setup() {
        return {
          hits: topicCloudData.hits || [],
          title: topicCloudData.title || undefined,
        };
      },
      template: `<TopicCloud :hits="hits" :title="title"></TopicCloud>`,
    }).mount("#vodl-topic-cloud-app");
  };

  init();
})(window, document);
